import { render } from "./WeaponBox.vue?vue&type=template&id=03bdfdfd"
import script from "./WeaponBox.vue?vue&type=script&lang=js"
export * from "./WeaponBox.vue?vue&type=script&lang=js"

import "./WeaponBox.vue?vue&type=style&index=0&id=03bdfdfd&lang=css"

import exportComponent from "C:\\Users\\windows\\Documents\\GitHub\\ValoAssist_web - 복사본\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__